import React, { useState, useEffect } from "react";
import { FaWarehouse, FaPeopleArrows, FaGlobe } from "react-icons/fa";

const GlobalPresence = () => {
  const [experience, setExperience] = useState(0);

  const targetExperience = 200;

  useEffect(() => {
    const experienceInterval = setInterval(() => {
      setExperience((prev) => {
        if (prev < targetExperience) {
          return prev + 1;
        } else {
          clearInterval(experienceInterval);
          return prev;
        }
      });
    }, 50);

    return () => {
      clearInterval(experienceInterval);
    };
  }, []);

  return (
    <div className="bg-blue-700  py-20 ">
      <div className="container mx-auto px-6 text-center  z-10">
        <h2 className="text-4xl text-white mb-8">
          TokenPocket is trusted by global users
        </h2>
        <p className="text-lg text-white mb-12">
          We are providing secure and easy crypto wallet service among 200+
          countries and regions around the world
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
          <div className="p-10 relative bg-blue-700 border rounded-lg flex flex-col justify-center items-center text-center">
            <FaWarehouse className="text-5xl text-white" />

            <p className="text-sm text-white relative ">Founded in</p>
            <h3 className="text-4xl font-bold text-white relative">2018</h3>
          </div>

          <div className="p-10 relative bg-blue-700 border rounded-lg flex flex-col justify-center items-center text-center">
            <FaPeopleArrows className="text-5xl text-white" />

            <p className="text-sm text-white relative ">Serving Users</p>
            <h3 className="text-4xl font-bold text-white relative ">25M+</h3>
          </div>

          <div className="p-10 relative bg-blue-700 border rounded-lg flex flex-col justify-center items-center text-center">
            <FaGlobe className="text-5xl text-white" />

            <p className="text-sm text-white relative ">
              Supporting countries and regions
            </p>
            <h3 className="text-4xl font-bold text-white relative ">
              {experience}+{" "}
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalPresence;
